import type { NonTerminalSurveyData, SurveyData } from 'bundles/onboarding-2022/types/Survey';

export const isNonTerminalSurvey = (surveyData?: SurveyData): surveyData is NonTerminalSurveyData => {
  return Boolean(surveyData && !surveyData.isTerminal);
};

export function getCurrentSection(sectionFlow: string[]) {
  if (sectionFlow.length > 0) {
    return sectionFlow[sectionFlow.length - 1];
  } else {
    return undefined;
  }
}
